// extracted by mini-css-extract-plugin
module.exports = {"card":"review_card__oo8IZ","actionsWrapper":"review_actionsWrapper__IUXxe"};